import React from 'react'
import cx from 'classnames'

type TSignUpInput = {
  name: string
  value: string
  hasError: boolean
  hasFocus: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onFocus: () => void
  onBlur: () => void
}

const SignUpInput: React.FC<TSignUpInput> = (props) => {
  const { name, value, hasError, hasFocus, onChange, onFocus, onBlur } = props
  return (
    <div
      className={cx('relative px-12 border-2', {
        'color-sale-red border-sale-red': hasError,
        'border-lightgrey': !hasError,
      })}
    >
      <label
        className={cx(
          'absolute top-0 left-0 text-iron origin-top-left transition-transform duration-200 leading-none',
          {
            'text-sale-red': hasError,
          },
        )}
        style={{
          transform:
            hasFocus || value.length ? 'translate(0.75rem, 0.375rem) scale(0.75)' : 'translate(0.75rem, 1rem) scale(1)',
        }}
        htmlFor={name}
      >
        E-Mail
      </label>
      <input
        className={cx('pt-16 h-48 w-full outline-none', { 'text-sale-red': hasError })}
        id={name}
        value={value}
        type="email"
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </div>
  )
}

export { SignUpInput as default }
